import type { ReactNode } from 'react'
import { toneClass, type ChipTone } from './tokens'

export type ChipVariant = 'wash' | 'outline' | 'solid'

export const Chip = ({
  tone = 'neutral',
  variant = 'wash',
  children,
  title,
  lead,
}: {
  tone?: ChipTone
  variant?: ChipVariant
  children: ReactNode
  title?: string
  lead?: ReactNode
}) => (
  <span className={`chip chip-${variant} ${toneClass(tone)}`} title={title}>
    {lead}
    {children}
  </span>
)
